import { normalizeVideoSource } from '../normalize-video-source';

/**
 * Read stable iframe content while preserving supported player and lazy-loader mutations.
 *
 * @since ??
 *
 * @param {HTMLIFrameElement} iframe Live or deferred video iframe.
 *
 * @returns {string} Content fingerprint without responsive geometry or playback parameters.
 */
export const getFitvidsIframeContent = (iframe: HTMLIFrameElement): string => {
  const source = iframe.getAttribute('src') || iframe.getAttribute('data-src');
  const attributes = Array.from(iframe.attributes)
    .filter(
      ({ name }) =>
        !['src', 'data-src', 'width', 'height', 'name', 'data-et-oembed-width', 'data-et-oembed-height'].includes(name),
    )
    .map(({ name, value }) => [name, value]);

  if (null !== source) {
    attributes.push(['src', normalizeVideoSource(source)]);
  }
  attributes.sort(([first], [second]) => first.localeCompare(second));

  return JSON.stringify([attributes, iframe.innerHTML]);
};
